import { setCartItems } from 'features/cart/cartSlice';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useSetCart = () => {
    const dispatch = useDispatch();

    const widgetReady = useSelector(
        (state) => state.miniBookingWidget.widgetReady
    );
    const cartItems = useSelector(
        (state) => state.miniBookingWidget?.data?.cart?.cartItems || []
    );
    let check = widgetReady;
    useEffect(() => {
        if (!widgetReady && !check) {
            return;
        }
        check = true;
        dispatch(setCartItems(cartItems));
    }, [widgetReady]);
};

export default useSetCart;
